import { LoadableRoute } from 'routes/utils/loadable';

export const SubscriptionPlanContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "SubscriptionPlan" */ './SubscriptionPlan'),
});
